<p-confirmDialog></p-confirmDialog>

<div *ngIf="!AccessAllowed && CompletedLoading">
  <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<div *ngIf="AccessAllowed" class="p-3 flex flex-column flex-auto">
    <div>
      <div class="text-900 font-medium text-xl mb-3">
        <h3>Venue Settings</h3>
      </div>

      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <p-tabView [(activeIndex)]="activeTabIndex" [style]="{'width':'100%'}">
            <p-tabPanel header="Venue Details" leftIcon="pi pi-home">
              <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
                <span class="pi pi-info-circle" style="margin-right:2px;"></span> Basic venue information.
              </p>
                <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium">Name</label>
                    <input id="VenueName" [(ngModel)]="Venue.data.name" [ngStyle]="{'border-color': (venueNameValid==false) ? '#FF0000':''}"  type="text" pInputText>
                  </div>
                  <div *ngIf="!venueNameValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Venue name.</div>
                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium">Address 1</label>
                    <input  id="Address1" [(ngModel)]="Venue.data.address1" [ngStyle]="{'border-color': (addressValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" type="text" pInputText>
                  </div>
                  <div *ngIf="!addressValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an Address.</div>
                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium">Address 2</label>
                    <input id="Address2" [(ngModel)]="Venue.data.address2"  type="text" pInputText>
                  </div>
                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium">Town/City</label>
                    <input  id="Town" [(ngModel)]="Venue.data.town" [ngStyle]="{'border-color': (townValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" type="text" pInputText>
                  </div>
                  <div *ngIf="!townValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Town/City.</div>
                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium">County</label>
                    <input  id="County" [(ngModel)]="Venue.data.county" [ngStyle]="{'border-color': (countyValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" type="text" pInputText>
                  </div>
                  <div *ngIf="!countyValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a County.</div>
                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium">PostCode</label>
                    <input id="PostCode"  [(ngModel)]="Venue.data.postcode" [ngStyle]="{'border-color': (postcodeValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" type="text" (change)="getLatLong(Venue.data.postcode)" pInputText>
                  </div>
                  <div *ngIf="!postcodeValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Postcode.</div>
                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium">Telephone</label>
                    <input id="Telephone" [(ngModel)]="Venue.data.telephone" [ngStyle]="{'border-color': (phoneValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" type="text" pInputText>
                  </div>
                  <div *ngIf="!phoneValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Telephone number.</div>
                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium">Email</label>
                    <input id="Email" [(ngModel)]="Venue.data.email" [ngStyle]="{'border-color': (emailValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" type="text" pInputText>
                  </div>
                  <div *ngIf="!emailValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an Email.</div>
                  <div style="display:none;">
                    <div class="field mb-4 col-12">
                      <label for="packageobjname" class="font-medium">Latitude</label>
                      <input id="Latitude"  type="text"  [(ngModel)]="Venue.data.lat" readonly="true" pInputText>
                    </div>
                    <div class="field mb-4 col-12">
                      <label for="packageobjname" class="font-medium">Longitude</label>
                      <input id="Longitude"  [(ngModel)]="Venue.data.lon" type="text" readonly="true" pInputText>
                    </div>
                </div>
                  <div class="field mb-4 col-12">
                    <label for="venueStartTime" class="font-medium">Venue Opening Time</label>
                    <br>
                    <p-dropdown [options]="venueStartTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueSelectedStartTimeHours" optionValue="code" optionLabel="name"></p-dropdown>
                    <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                    <p-dropdown [options]="venueStartTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueSelectedStartTimeMins" optionValue="code" optionLabel="name"></p-dropdown>
                    
                    <div style="clear:both;"></div>
                  </div>
                  <div class="field mb-4 col-12">
                    <label for="venueEndTime" class="font-medium">Venue Closing Time</label>
                    <br>
                    <p-dropdown [options]="venueEndTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueSelectedEndTimeHours" optionValue="code" optionLabel="name"></p-dropdown>
                    <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                    <p-dropdown [options]="venueEndTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueSelectedEndTimeMins" optionValue="code" optionLabel="name"></p-dropdown>

                    <div style="clear:both;"></div>
                    
                  </div>
                  
                  <!-- <div class="field mb-4 col-12">
                    <label for="capacity" class="font-medium">Venue Capacity</label>
                    <p-inputNumber id="capacity" [style]="{'width': '300px'}" [(ngModel)]="Venue.data.capacity" [showButtons]="true" max="9999" min="0" buttonLayout="horizontal" spinnerMode="horizontal" (onInput)="DoValidCheck()"></p-inputNumber>
                  </div> -->

                  <!-- <div class="field mb-4 col-12">
                    <label for="includeParticipants" class="font-medium">Include Participants in Venue Capacity</label>
                    <p-selectButton [(ngModel)] = "VCapacityIncludesParticipant" [style]="{'width': '150px'}" [options]="includeParticipants" ></p-selectButton>
                  </div> -->

                  <div *ngIf="!capacityValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Venue Capacity greater than zero.</div>

                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium">Booking ID Prefix</label>
                    <input id="prefix" [(ngModel)]="this.Venue.data.prefix" [maxlength]="4" [ngStyle]="{'border-color': (prefixValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" type="text" pInputText>
                  </div>
                  <div *ngIf="!prefixValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an Prefix.</div>
                  
                  <!-- What confirmations and email templates offer as the venue's customer
                       services contact, so it is set once here rather than typed into every one. -->
                  <div class="field mb-4 col-12">
                    <label for="customerserviceemail" class="font-medium">Customer services - email</label>
                    <input id="customerserviceemail" [(ngModel)]="CustomerServiceEmail" type="text" pInputText>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="customerservicephone" class="font-medium">Customer services - phone</label>
                    <input id="customerservicephone" [(ngModel)]="CustomerServicePhone" type="text" pInputText>
                  </div>

                  <div style="clear:both;width:100%"></div>

                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium" style="float:left;">Public Booking Link</label>
                    
                    <div style="clear:both;width:100%"></div>

                    <input id="prefix" [(ngModel)]="PublicHostName" [readOnly]="true" type="text" pInputText style="float:left; width:50%;">

                    <button pButton type="button" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" style="width:184px;float:left; margin-left:10px; height:50px;" (click)="copyData(PublicHostName);" i18>
                      <span class="pi pi-copy" style="margin-right:8px;"></span>
                      <span i18n>Copy to clipboard</span>
                  </button>

                  </div>

                  <div style="clear:both;width:100%"></div>

                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium" style="float:left;">Public Events Link</label>
                    
                    <div style="clear:both;width:100%"></div>

                    <input id="prefix" [(ngModel)]="PublicHostNameEvents" [readOnly]="true" type="text" pInputText style="float:left; width:50%;">
                    
                    <button pButton type="button" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" style="width:184px;float:left; margin-left:10px; height:50px;" (click)="copyData(PublicHostNameEvents);" i18>
                      <span class="pi pi-copy" style="margin-right:8px;"></span>
                      <span i18n>Copy to clipboard</span>
                  </button>
                  </div>

                  <div style="clear:both;width:100%"></div>

                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium" style="float:left;">Public Voucher Link</label>

                    <div style="clear:both;width:100%"></div>

                    <input id="prefix" [(ngModel)]="PublicHostNameVoucher" [readOnly]="true" type="text" pInputText style="float:left; width:50%;">

                    <button pButton type="button" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" style="width:184px;float:left; margin-left:10px; height:50px;" (click)="copyData(PublicHostNameVoucher);" i18>
                      <span class="pi pi-copy" style="margin-right:8px;"></span>
                      <span i18n>Copy to clipboard</span>
                  </button>
                  </div>

                  <div style="clear:both;width:100%"></div>

                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium" style="float:left;">Public Membership Link</label>

                    <div style="clear:both;width:100%"></div>

                    <input id="prefix" [(ngModel)]="PublicHostNameMembership" [readOnly]="true" type="text" pInputText style="float:left; width:50%;">

                    <button pButton type="button" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" style="width:184px;float:left; margin-left:10px; height:50px;" (click)="copyData(PublicHostNameMembership);" i18>
                        <span class="pi pi-copy" style="margin-right:8px;"></span>
                        <span i18n>Copy to clipboard</span>
                    </button>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium" style="float:left;">Public Scheduled Session Link</label>

                    <div style="clear:both;width:100%"></div>

                    <input id="prefix" [(ngModel)]="PublicHostNameScheduledSession" [readOnly]="true" type="text" pInputText style="float:left; width:50%;">

                    <button pButton type="button" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" style="width:184px;float:left; margin-left:10px; height:50px;" (click)="copyData(PublicHostNameScheduledSession);" i18>
                        <span class="pi pi-copy" style="margin-right:8px;"></span>
                        <span i18n>Copy to clipboard</span>
                    </button>
                  </div>

                  <div style="clear:both;width:100%"></div>

                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium" style="float:left;">Venue Waiver Link</label>

                    <div style="clear:both;width:100%"></div>

                    <input id="prefix" [(ngModel)]="PublicWaiverForGroup" [readOnly]="true" type="text" pInputText style="float:left; width:50%;">

                    <button pButton type="button" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" style="width:184px;float:left; margin-left:10px; height:50px;" (click)="copyData(PublicWaiverForGroup);" i18>
                        <span class="pi pi-copy" style="margin-right:8px;"></span>
                        <span i18n>Copy to clipboard</span>
                    </button>
                  </div>

                  <div style="clear:both;width:100%"></div>

                  <div class="field mb-4 col-12">
                    <label for="appLink" class="font-medium" style="float:left;">App Link</label>

                    <div style="clear:both;width:100%"></div>

                    <input id="appLink" [ngModel]="'https://app.wannabook.online'" [readOnly]="true" type="text" pInputText style="float:left; width:50%;">

                    <button pButton type="button" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" style="width:184px;float:left; margin-left:10px; height:50px;" (click)="copyData('https://app.wannabook.online');">
                        <span class="pi pi-copy" style="margin-right:8px;"></span>
                        <span i18n>Copy to clipboard</span>
                    </button>
                  </div>

                  <div style="clear:both;width:100%"></div>

                  <div class="col-12"> 
                    <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                    Save Changes</button>
                    &nbsp;
                    <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnHome()">
                    <span class="pi pi-times" style="margin-right:8px;"></span>
                    Cancel</button>
                </div>
            </p-tabPanel>
            <!-- <p-tabPanel header="Venue Start Times" leftIcon="pi pi-clock">
              <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
                <span class="pi pi-info-circle" style="margin-right:2px;"></span> The opening hours for your venue.
              </p>
              <p-accordion [style]="{'width':'100%'}">
                <p-accordionTab >
                  <p-header style="width:100%">
                    <div style="width:100%">
                        <span class="pi pi-clock" style="margin-right: 10px;font-size:20px;"></span><span style="font-size:17px;">Monday ({{venueStartTime}} - {{venueEndTime}})&nbsp;({{mondaySelectedTimes.length}}&nbsp;times selected)</span>
                    </div>
                </p-header>
                <div class="field mb-4 col-12">
                  <div class="field mb-4 col-12">
                    <label for="MondayTimes" class="font-medium">Selected Times</label>
                    <div *ngFor="let t of mondaySelectedTimes">
                        <p-chip *ngIf="(t.index >= startTimeIndex && t.index < endTimeIndex)" label="{{t.time}}" [removable]="true" styleClass="custom-chip" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveMondayChip(t.time)"></p-chip>
                        <p-chip *ngIf="t.index < startTimeIndex || t.index >= endTimeIndex" label="{{t.time}}"  label="{{t.time}}" [removable]="true" styleClass="custom-chip3" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveMondayChip(t.time)"></p-chip>
                      </div>
                    <div style="clear:both; margin-top:65px;"></div> 

                    <div style="width: 424px;float: left;border-right: dashed black 1px;margin-right: 15px;margin-top: 10px;">
                      <div style="margin-top:10px; margin-bottom:10px;">
                        Template
                      </div>
                      <p-dropdown [options]="mondayTemplate" [style]="{'width': '300px', 'float':'left', 'margin-right':'10px'}"  [(ngModel)]="mondaySelectedTemplate" optionValue="time" optionLabel="templatename"></p-dropdown>
                      <button pButton type="button" style="height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addTemplatedMonday()">
                        <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                        <span>Add</span>
                      </button>
                    </div>

                    <div style="width: 424px; float: left;margin-top: 10px;">
                      <div style="margin-top:10px; margin-bottom:10px;">
                        Ad Hoc
                      </div>
                        <p-dropdown [options]="venueMondayStartTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueMondaySelectedStartTimeHours" optionValue="code" optionLabel="name"></p-dropdown>
                        <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                        <p-dropdown [options]="venueMondayStartTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueMondaySelectedStartTimeMins" optionValue="code" optionLabel="name"></p-dropdown>
                      
                      <button pButton type="button" style="margin-left: 10px;height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addAdHocMonday()">
                        <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                        <span>Add</span>
                      </button>

                    </div>
                    <div style="float:left; margin-top:20px; text-align:center;">
                      <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="MondayCopy('ToWeek')">
                        <span class="pi pi-angle-double-down" style="margin-right:8px;"></span>
                        <span>Copy to all Week</span>
                      </button>

                      <button pButton type="button" style="height: 37px; width:320px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="MondayCopy('ToWeekExcWE')">
                        <span class="pi pi-angle-down" style="margin-right:8px;"></span>
                        <span>Copy to all Week (Excl Weekend)</span>
                      </button>

                      <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="MondayCopy('ToWeekEnd')">
                        <span class="pi pi-angle-right" style="margin-right:8px;"></span>
                        <span>Copy to Weekend</span>
                      </button>

                      <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="ClearTimesMonday()">
                        <span class="pi pi-times" style="margin-right:8px;"></span>
                        <span>Clear Times</span>
                      </button>
                    </div>
                    
                  </div>
                </div><div style="clear:both;"></div>
              </p-accordionTab>
              <p-accordionTab>
                <p-header style="width:100%">
                  <div style="width:100%">
                      <span class="pi pi-clock" style="margin-right: 10px;font-size:20px;"></span><span style="font-size:17px;">Tuesday ({{venueStartTime}} - {{venueEndTime}})&nbsp;({{tuesdaySelectedTimes.length}}&nbsp;times selected)</span>
                  </div>
              </p-header>
              <div class="field mb-4 col-12">
                <div class="field mb-4 col-12">
                  <label for="TuesdayTimes" class="font-medium">Selected Times</label>
                  <div *ngFor="let t of tuesdaySelectedTimes">
                      <p-chip *ngIf="(t.index >= startTimeIndex && t.index < endTimeIndex)" label="{{t.time}}" [removable]="true" styleClass="custom-chip" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveTuesdayChip(t.time)"></p-chip>
                      <p-chip *ngIf="t.index < startTimeIndex || t.index >= endTimeIndex" label="{{t.time}}"  label="{{t.time}}" [removable]="true" styleClass="custom-chip3" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveTuesdayChip(t.time)"></p-chip>
                 
                  </div>
                  <div style="clear:both; margin-top:65px;"></div> 

                  <div style="width: 424px;float: left;border-right: dashed black 1px;margin-right: 15px;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Template
                    </div>
                    <p-dropdown [options]="tuesdayTemplate" [style]="{'width': '300px', 'float':'left', 'margin-right':'10px'}"  [(ngModel)]="tuesdaySelectedTemplate" optionValue="time" optionLabel="templatename"></p-dropdown>
                    <button pButton type="button" style="height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addTemplatedTuesday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>
                  </div>

                  <div style="width: 424px; float: left;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Ad Hoc
                    </div>
                      <p-dropdown [options]="venueTuesdayStartTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueTuesdaySelectedStartTimeHours" optionValue="code" optionLabel="name"></p-dropdown>
                      <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                      <p-dropdown [options]="venueTuesdayStartTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueTuesdaySelectedStartTimeMins" optionValue="code" optionLabel="name"></p-dropdown>
                    
                    <button pButton type="button" style="margin-left: 10px;height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addAdHocTuesday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>

                  </div>
                  <div style="float:left; margin-top:20px; text-align:center;">
                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="TuesdayCopy('ToWeek')">
                      <span class="pi pi-angle-double-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:320px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="TuesdayCopy('ToWeekExcWE')">
                      <span class="pi pi-angle-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week (Excl Weekend)</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="TuesdayCopy('ToWeekEnd')">
                      <span class="pi pi-angle-right" style="margin-right:8px;"></span>
                      <span>Copy to Weekend</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="ClearTimesTuesday()">
                      <span class="pi pi-times" style="margin-right:8px;"></span>
                      <span>Clear Times</span>
                    </button>
                  </div>
                 
                </div> 
              </div><div style="clear:both;"></div>
              </p-accordionTab>
              <p-accordionTab>
                <p-header style="width:100%">
                  <div style="width:100%">
                      <span class="pi pi-clock" style="margin-right: 10px;font-size:20px;"></span><span style="font-size:17px;">Wednesday ({{venueStartTime}} - {{venueEndTime}})&nbsp;({{wednesdaySelectedTimes.length}}&nbsp;times selected)</span>
                  </div>
              </p-header>
              <div class="field mb-4 col-12">
                <div class="field mb-4 col-12">
                  <label for="WednesdayTimes" class="font-medium">Selected Times</label>
                  <div *ngFor="let t of wednesdaySelectedTimes">
                      <p-chip *ngIf="(t.index >= startTimeIndex && t.index < endTimeIndex)" label="{{t.time}}" [removable]="true" styleClass="custom-chip" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveWednesdayChip(t.time)"></p-chip>
                      <p-chip *ngIf="t.index < startTimeIndex || t.index >= endTimeIndex" label="{{t.time}}"  label="{{t.time}}" [removable]="true" styleClass="custom-chip3" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveWednesdayChip(t.time)"></p-chip>
                    </div>
                  <div style="clear:both; margin-top:65px;"></div> 

                  <div style="width: 424px;float: left;border-right: dashed black 1px;margin-right: 15px;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Template
                    </div>
                    <p-dropdown [options]="wednesdayTemplate" [style]="{'width': '300px', 'float':'left', 'margin-right':'10px'}"  [(ngModel)]="wednesdaySelectedTemplate" optionValue="time" optionLabel="templatename"></p-dropdown>
                    <button pButton type="button" style="height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addTemplatedWednesday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>
                  </div>

                  <div style="width: 424px; float: left;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Ad Hoc
                    </div>
                      <p-dropdown [options]="venueWednesdayStartTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueWednesdaySelectedStartTimeHours" optionValue="code" optionLabel="name"></p-dropdown>
                      <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                      <p-dropdown [options]="venueWednesdayStartTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueWednesdaySelectedStartTimeMins" optionValue="code" optionLabel="name"></p-dropdown>
                    
                    <button pButton type="button" style="margin-left: 10px;height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addAdHocWednesday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>

                  </div>
                  <div style="float:left; margin-top:20px; text-align:center;">
                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="WednesdayCopy('ToWeek')">
                      <span class="pi pi-angle-double-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:320px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="WednesdayCopy('ToWeekExcWE')">
                      <span class="pi pi-angle-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week (Excl Weekend)</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="WednesdayCopy('ToWeekEnd')">
                      <span class="pi pi-angle-right" style="margin-right:8px;"></span>
                      <span>Copy to Weekend</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="ClearTimesWednesday()">
                      <span class="pi pi-times" style="margin-right:8px;"></span>
                      <span>Clear Times</span>
                    </button>
                  </div>
                </div>
                
              </div><div style="clear:both;"></div>
              </p-accordionTab>
              <p-accordionTab>
                <p-header style="width:100%">
                  <div style="width:100%">
                      <span class="pi pi-clock" style="margin-right: 10px;font-size:20px;"></span><span style="font-size:17px;">Thursday ({{venueStartTime}} - {{venueEndTime}})&nbsp;({{thursdaySelectedTimes.length}}&nbsp;times selected)</span>
                  </div>
              </p-header>
              <div class="field mb-4 col-12">
                <div class="field mb-4 col-12">
                  <label for="ThursdayTimes" class="font-medium">Selected Times</label>
                  <div *ngFor="let t of thursdaySelectedTimes">
                      <p-chip *ngIf="(t.index >= startTimeIndex && t.index < endTimeIndex)" label="{{t.time}}" [removable]="true" styleClass="custom-chip" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveThursdayChip(t.time)"></p-chip>
                      <p-chip *ngIf="t.index < startTimeIndex || t.index >= endTimeIndex" label="{{t.time}}"  label="{{t.time}}" [removable]="true" styleClass="custom-chip3" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveThursdayChip(t.time)"></p-chip>
                    </div>
                  <div style="clear:both; margin-top:65px;"></div> 

                  <div style="width: 424px;float: left;border-right: dashed black 1px;margin-right: 15px;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Template
                    </div>
                    <p-dropdown [options]="thursdayTemplate" [style]="{'width': '300px', 'float':'left', 'margin-right':'10px'}"  [(ngModel)]="thursdaySelectedTemplate" optionValue="time" optionLabel="templatename"></p-dropdown>
                    <button pButton type="button" style="height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addTemplatedThursday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>
                  </div>

                  <div style="width: 424px; float: left;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Ad Hoc
                    </div>
                      <p-dropdown [options]="venueThursdayStartTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueThursdaySelectedStartTimeHours" optionValue="code" optionLabel="name"></p-dropdown>
                      <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                      <p-dropdown [options]="venueThursdayStartTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueThursdaySelectedStartTimeMins" optionValue="code" optionLabel="name"></p-dropdown>
                    
                    <button pButton type="button" style="margin-left: 10px;height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addAdHocThursday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>

                  </div>
                  <div style="float:left; margin-top:20px; text-align:center;">
                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="ThursdayCopy('ToWeek')">
                      <span class="pi pi-angle-double-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:320px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="ThursdayCopy('ToWeekExcWE')">
                      <span class="pi pi-angle-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week (Excl Weekend)</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="ThursdayCopy('ToWeekEnd')">
                      <span class="pi pi-angle-right" style="margin-right:8px;"></span>
                      <span>Copy to Weekend</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="ClearTimesThursday()">
                      <span class="pi pi-times" style="margin-right:8px;"></span>
                      <span>Clear Times</span>
                    </button>
                  </div>
                </div>
                
              </div><div style="clear:both;"></div>
              </p-accordionTab>
              <p-accordionTab>
                <p-header style="width:100%">
                  <div style="width:100%">
                      <span class="pi pi-clock" style="margin-right: 10px;font-size:20px;"></span><span style="font-size:17px;">Friday ({{venueStartTime}} - {{venueEndTime}})&nbsp;({{fridaySelectedTimes.length}}&nbsp;times selected)</span>
                  </div>
              </p-header>
              <div class="field mb-4 col-12">
                <div class="field mb-4 col-12">
                  <label for="FridayTimes" class="font-medium">Selected Times</label>
                  <div *ngFor="let t of fridaySelectedTimes">
                      <p-chip *ngIf="(t.index >= startTimeIndex && t.index < endTimeIndex)" label="{{t.time}}" [removable]="true" styleClass="custom-chip" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveFridayChip(t.time)"></p-chip>
                      <p-chip *ngIf="t.index < startTimeIndex || t.index >= endTimeIndex" label="{{t.time}}"  label="{{t.time}}" [removable]="true" styleClass="custom-chip3" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveFridayChip(t.time)"></p-chip>
                    </div>
                  <div style="clear:both; margin-top:65px;"></div> 

                  <div style="width: 424px;float: left;border-right: dashed black 1px;margin-right: 15px;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Template
                    </div>
                    <p-dropdown [options]="fridayTemplate" [style]="{'width': '300px', 'float':'left', 'margin-right':'10px'}"  [(ngModel)]="fridaySelectedTemplate" optionValue="time" optionLabel="templatename"></p-dropdown>
                    <button pButton type="button" style="height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addTemplatedFriday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>
                  </div>

                  <div style="width: 424px; float: left;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Ad Hoc
                    </div>
                      <p-dropdown [options]="venueFridayStartTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueFridaySelectedStartTimeHours" optionValue="code" optionLabel="name"></p-dropdown>
                      <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                      <p-dropdown [options]="venueFridayStartTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueFridaySelectedStartTimeMins" optionValue="code" optionLabel="name"></p-dropdown>
                    
                    <button pButton type="button" style="margin-left: 10px;height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addAdHocFriday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>

                  </div>
                  <div style="float:left; margin-top:20px; text-align:center;">
                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="FridayCopy('ToWeek')">
                      <span class="pi pi-angle-double-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:320px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="FridayCopy('ToWeekExcWE')">
                      <span class="pi pi-angle-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week (Excl Weekend)</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="FridayCopy('ToWeekEnd')">
                      <span class="pi pi-angle-right" style="margin-right:8px;"></span>
                      <span>Copy to Weekend</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="ClearTimesFriday()">
                      <span class="pi pi-times" style="margin-right:8px;"></span>
                      <span>Clear Times</span>
                    </button>
                  </div>
                  
                </div>
              </div><div style="clear:both;"></div>
              </p-accordionTab>
              <p-accordionTab>
                <p-header style="width:100%">
                  <div style="width:100%">
                      <span class="pi pi-clock" style="margin-right: 10px;font-size:20px;"></span><span style="font-size:17px;">Saturday ({{venueStartTime}} - {{venueEndTime}})&nbsp;({{saturdaySelectedTimes.length}}&nbsp;times selected)</span>
                  </div>
              </p-header>
              <div class="field mb-4 col-12">
                <div class="field mb-4 col-12">
                  <label for="SaturdayTimes" class="font-medium">Selected Times</label>
                  <div *ngFor="let t of saturdaySelectedTimes">
                      <p-chip *ngIf="(t.index >= startTimeIndex && t.index < endTimeIndex)" label="{{t.time}}" [removable]="true" styleClass="custom-chip" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveSaturdayChip(t.time)"></p-chip>
                      <p-chip *ngIf="t.index < startTimeIndex || t.index >= endTimeIndex" label="{{t.time}}"  label="{{t.time}}" [removable]="true" styleClass="custom-chip3" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveSaturdayChip(t.time)"></p-chip>
                    </div>
                  <div style="clear:both; margin-top:65px;"></div> 

                  <div style="width: 424px;float: left;border-right: dashed black 1px;margin-right: 15px;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Template
                    </div>
                    <p-dropdown [options]="saturdayTemplate" [style]="{'width': '300px', 'float':'left', 'margin-right':'10px'}"  [(ngModel)]="saturdaySelectedTemplate" optionValue="time" optionLabel="templatename"></p-dropdown>
                    <button pButton type="button" style="height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addTemplatedSaturday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>
                  </div>

                  <div style="width: 424px; float: left;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Ad Hoc
                    </div>
                      <p-dropdown [options]="venueSaturdayStartTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueSaturdaySelectedStartTimeHours" optionValue="code" optionLabel="name"></p-dropdown>
                      <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                      <p-dropdown [options]="venueSaturdayStartTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueSaturdaySelectedStartTimeMins" optionValue="code" optionLabel="name"></p-dropdown>
                    
                    <button pButton type="button" style="margin-left: 10px;height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addAdHocSaturday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>

                  </div>
                  <div style="float:left; margin-top:20px; text-align:center;">
                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="SaturdayCopy('ToWeek')">
                      <span class="pi pi-angle-double-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:320px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="SaturdayCopy('ToWeekExcWE')">
                      <span class="pi pi-angle-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week (Excl Weekend)</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="SaturdayCopy('ToWeekEnd')">
                      <span class="pi pi-angle-right" style="margin-right:8px;"></span>
                      <span>Copy to Weekend</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="ClearTimesSaturday()">
                      <span class="pi pi-times" style="margin-right:8px;"></span>
                      <span>Clear Times</span>
                    </button>
                  </div>
                  
                </div>
              </div><div style="clear:both;"></div>
              </p-accordionTab>
              <p-accordionTab>
                <p-header style="width:100%">
                  <div style="width:100%">
                      <span class="pi pi-clock" style="margin-right: 10px;font-size:20px;"></span><span style="font-size:17px;">Sunday ({{venueStartTime}} - {{venueEndTime}})&nbsp;({{sundaySelectedTimes.length}}&nbsp;times selected)</span>
                  </div>
              </p-header>
              <div class="field mb-4 col-12">
                <div class="field mb-4 col-12">
                  <label for="SundayTimes" class="font-medium">Selected Times</label>
                  <div *ngFor="let t of sundaySelectedTimes">
                      <p-chip *ngIf="(t.index >= startTimeIndex && t.index < endTimeIndex)" label="{{t.time}}" [removable]="true" styleClass="custom-chip" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveSundayChip(t.time)"></p-chip>
                      <p-chip *ngIf="t.index < startTimeIndex || t.index >= endTimeIndex" label="{{t.time}}"  label="{{t.time}}" [removable]="true" styleClass="custom-chip3" [style]="{'float':'left','margin-right':'5px','margin-bottom':'5px','width':'100px;'}" (onRemove)="RemoveSundayChip(t.time)"></p-chip>
                    </div>
                  <div style="clear:both; margin-top:65px;"></div> 

                  <div style="width: 424px;float: left;border-right: dashed black 1px;margin-right: 15px;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Template
                    </div>
                    <p-dropdown [options]="sundayTemplate" [style]="{'width': '300px', 'float':'left', 'margin-right':'10px'}"  [(ngModel)]="sundaySelectedTemplate" optionValue="time" optionLabel="templatename"></p-dropdown>
                    <button pButton type="button" style="height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addTemplatedSunday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>
                  </div>

                  <div style="width: 424px; float: left;margin-top: 10px;">
                    <div style="margin-top:10px; margin-bottom:10px;">
                      Ad Hoc
                    </div>
                      <p-dropdown [options]="venueSundayStartTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueSundaySelectedStartTimeHours" optionValue="code" optionLabel="name"></p-dropdown>
                      <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                      <p-dropdown [options]="venueSundayStartTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="venueSundaySelectedStartTimeMins" optionValue="code" optionLabel="name"></p-dropdown>
                    
                    <button pButton type="button" style="margin-left: 10px;height: 35px; width: 80px;float: left;margin-right: -1px;font-size: 15px;margin-top: 7px;" class="p-button-sm p-button-success p-element p-ripple p-button p-component" (click)="addAdHocSunday()">
                      <span class="pi pi-plus" style="margin-right:5px; font-size:14px;margin-left: -2px;"></span>
                      <span>Add</span>
                    </button>

                  </div>
                  <div style="float:left; margin-top:20px; text-align:center;">
                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="SundayCopy('ToWeek')">
                      <span class="pi pi-angle-double-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:320px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="SundayCopy('ToWeekExcWE')">
                      <span class="pi pi-angle-down" style="margin-right:8px;"></span>
                      <span>Copy to all Week (Excl Weekend)</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="SundayCopy('ToWeekEnd')">
                      <span class="pi pi-angle-right" style="margin-right:8px;"></span>
                      <span>Copy to Weekend</span>
                    </button>

                    <button pButton type="button" style="height: 37px; width:200px; float:left; margin-right:10px; font-size:16px; margin-bottom:5px;" class="p-button-sm p-button-secondary p-element p-ripple p-button p-component" (click)="ClearTimesSunday()">
                      <span class="pi pi-times" style="margin-right:8px;"></span>
                      <span>Clear Times</span>
                    </button>
                  </div>
                  
                </div>
              </div><div style="clear:both;"></div>
              </p-accordionTab>
            </p-accordion>
            <div class="col-12"> 
              <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateStartTimeData();">
              <span class="pi pi-pencil" style="margin-right:8px;"></span>
              Save Changes</button>
              &nbsp;
              <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnHome()">
              <span class="pi pi-times" style="margin-right:8px;"></span>
              Cancel</button>
          </div>
            </p-tabPanel> -->
            <p-tabPanel header="Settings" leftIcon="pi pi-cog">
              <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
                <span class="pi pi-info-circle" style="margin-right:2px;"></span> Ad hoc information for this venue.
              </p>
              <p-accordion [(activeIndex)]="settingsAccordionIndex">
                <p-accordionTab>

                  <p-header style="width:100%">
                    <div style="width:100%">
                        <span class="pi pi-cog" style="margin-right: 10px;"></span>
                        General Settings
                    </div>
                  </p-header>

                  <div class="field mb-4 col-12" style="border: 2px solid #dc3545; border-radius: 6px; padding: 16px; background-color: #fff5f5;">
                    <div style="display: flex; align-items: center; margin-bottom: 8px;">
                      <span class="pi pi-exclamation-triangle" style="color: #dc3545; font-size: 1.2rem; margin-right: 8px;"></span>
                      <label for="StopPublicBookings" class="font-medium" style="color: #dc3545; font-size: 1rem; margin: 0;">Stop Public Bookings</label>
                    </div>
                    <p style="color: #dc3545; margin: 0 0 10px 0; font-size: 0.875rem;">
                      <strong>Warning:</strong> Enabling this setting will prevent customers from making any public bookings. Only turn this on if you need to temporarily halt all online booking activity.
                    </p>
                    <p-selectButton [(ngModel)]="StopPublicBookings" [style]="{'width': '150px'}" [options]="StopPublicBookingsStateOptions" (onChange)="onStopPublicBookingsChange($event)"></p-selectButton>
                  </div>

                  <!-- <div class="field mb-4 col-12">
                    <label for="diagnosticsMode" class="font-medium">Public Booking Wizard Style</label>
                    <p-selectButton [(ngModel)] = "vsPBWStyle" [style]="{'width': '300px'}" [options]="PBWStyleStateOptions" ></p-selectButton>
                  </div> -->

                  <div class="field mb-4 col-12">
                    <label for="diagnosticsMode" class="font-medium">Availability Diagnostics Mode</label>
                    <p-selectButton [(ngModel)] = "vsDiagnostics" [style]="{'width': '150px'}" [options]="diagnosticsModeStateOptions" ></p-selectButton>
                  </div>


                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium" style="float:left;">No Availability Message</label>

                    <div style="clear:both;width:100%"></div>

                    <input id="prefix" [(ngModel)]="NoAvailabilityMessage" type="text" pInputText style="float:left; width:50%;">

                  </div>

                  <div style="clear:both;width:100%"></div>

                  <div class="field mb-4 col-12" style="margin-top: 20px;">
                    <label for="minimalDetails" class="font-medium">Use Minimal Customer Details</label>
                    <p-selectButton [(ngModel)] = "vsMinimalDetails" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions" ></p-selectButton>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="notesonpbw" class="font-medium">Allow Notes on Public Booking Wizard</label>
                    <p-selectButton [(ngModel)]="notesonpbw" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions"></p-selectButton>
                  </div>

                  <!-- <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Send Email/SMS Confirmations</label>
                    <p-selectButton [(ngModel)] = "vsConfirmations" [style]="{'width': '300px'}" [options]="ConfirmationsStateOptions" ></p-selectButton>
                  </div> -->

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Default Interval for Day Sheets</label>
                    <p-inputNumber id="defInterval" [style]="{'width': '300px'}" [(ngModel)]="defInterval== null ? 5: defInterval" [showButtons]="true" max="240" min="5" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>
                  </div>
                  <!-- 
                  <div class="field mb-4 col-12">
                    <label for="minimalDetails" class="font-medium">Session Timeout?</label>
                    <p-selectButton [(ngModel)] = "AllowTimeOut" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions" ></p-selectButton>
                  </div>

                  <div *ngIf="AllowTimeOut" class="field mb-4 col-12">
                    <label for="" class="font-medium">Time out for idle sessions in seconds</label>
                    <p-inputNumber id="idleTimeout" [style]="{'width': '300px'}" [(ngModel)]="idleTimeout== null ? 1: idleTimeout" [showButtons]="true" max="3600" min="10" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>
                  </div> -->

                  <div class="field mb-4 col-12">
                    <label for="UseCounters" class="font-medium">Use Counters</label>
                    <p-selectButton [(ngModel)] = "UseCounters" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions" ></p-selectButton>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="IgnoreDateRestrictions" class="font-medium">Ignores Date Restrictions for Venue bookings</label>
                    <p-selectButton [(ngModel)] = "IgnoreDateRestrictions" [style]="{'width': '150px'}" [options]="IgnoreDateRestrictionsStateOptions" ></p-selectButton>
                  </div>

                  <!-- <div class="field mb-4 col-12">
                    <label for="AllowResourcesChangedManually" class="font-medium">Allow Resources to be Changed Manually</label>
                    <p-selectButton [(ngModel)]="AllowResourcesChangedManually" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions"></p-selectButton>
                  </div> -->

                  <div class="field mb-4 col-12">
                    <label for="ReturnResourceSpaceOnCustomerLeaving" class="font-medium">Return Resource Space on Customer Leaving</label>
                    <p-selectButton [(ngModel)]="ReturnResourceSpaceOnCustomerLeaving" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions"></p-selectButton>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Google Tag Manager ID</label><br>
                    <input style="width:300px;" [(ngModel)]="GoogleTagManagerID" id="hexcolour" type="text" [maxlength]="12" pInputText>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Return page for public booking after payment</label><br>
                    <input style="width:300px;" [(ngModel)]="returnPage" (blur)="ensureHttpPrefix('returnPage')" id="returnPage" type="text" [maxlength]="255" pInputText [ngStyle]="{'border-color': !returnPageValid ? '#FF0000':''}">
                  </div>
                  <div *ngIf="!returnPageValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Return page.</div>

                  <div class="field mb-4 col-12" style="width:100%">
                    <label for="" class="font-medium">Currency</label><br>
                    <p-dropdown [options]="Currencies" [style]="{'width': '300px', 'float': 'left'}"  [(ngModel)]="chosenCurrency" optionLabel="name" optionValue="code"></p-dropdown>
                  </div>

                  <div style="clear:both;width:100%;">&nbsp;</div>
                  
                  <div class="field mb-4 col-12" style="width:100%;margin-top:20px;">
                    <label for="" class="font-medium">Timezone</label><br>
                    <p-dropdown [options]="timezones" [style]="{'width': '300px', 'float': 'left'}"  [(ngModel)]="chosenTimezone" optionLabel="name" optionValue="value"></p-dropdown>
                  </div>
                  
                  <div style="clear:both;width:100%;"></div>

                  <div class="field mb-4 col-12" style="width:100%;margin-top:20px;">
                    <label for="" class="font-medium">Language</label><br>
                    <p-dropdown [options]="cultures" [style]="{'width': '300px', 'float': 'left'}"  [(ngModel)]="chosenCulture" optionLabel="name" optionValue="code"></p-dropdown>
                  </div>

                  <div style="clear:both;width:100%;">&nbsp;</div><br>
                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Booking Notification Email</label><br>
                    <input style="width:300px;" [(ngModel)]="BNemail" id="bookingNotificationEmail" type="text" [maxlength]="255" pInputText>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="BookingNotification" class="font-medium">Send Booking Notification</label>
                    <p-selectButton [(ngModel)]="BookingNotification" [style]="{'width': '150px'}" [options]="BNStateOptions" ></p-selectButton>
                  </div>

                  <div style="clear:both;width:100%"></div>

                  <div class="field mb-4 col-12">
                    <label for="packageobjname" class="font-medium" style="float:left;">Webhook URL</label>

                    <div style="clear:both;width:100%"></div>

                    <input id="webhookURL" [(ngModel)]="WebhookURL" type="text" pInputText style="float:left; width:50%;">

                  </div>

                  <div style="clear:both;width:100%;">&nbsp;</div>

              </p-accordionTab>
                <p-accordionTab>

                  <p-header style="width:100%">
                    <div style="width:100%">
                        <span class="pi pi-desktop" style="margin-right: 10px;"></span>
                          Tills and Terminals
                    </div>
                  </p-header>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Till Access (Requires you to logout and back in again to show change.)</label><br>
                    <p-selectButton [(ngModel)]="TillAccess" [style]="{'width': '150px'}" [options]="TillAccessStateOptions"></p-selectButton>
                  </div>

                  <div *ngIf="TillAccess" class="field mb-4 col-12">
                    <label for="tillname" class="font-medium">Till Name <span style="font-weight:400; color:#6b7280;">(saved per device, not to the database)</span></label>
                    <br>
                    <input id="tillname" [(ngModel)]="TillName" type="text" pInputText placeholder="e.g. Front Desk, Bar, Reception" style="max-width:400px;">
                  </div>

                  <div *ngIf="TillAccess" class="field mb-4 col-12">
                    <label for="terminalname" class="font-medium">Terminal Name for Till</label>
                    <br>
                    <p-dropdown
                      id="terminalname"
                      name="terminalname"
                      [options]="StripeTerminals"
                      [ngModel]="selectedTerminal"
                      (onChange)="onTerminalChange($event)"
                      (onClear)="selectedTerminal = null"
                      optionLabel="label"
                      placeholder="Choose Terminal"
                      [showClear]="true"
                      style="max-width:400px; display:block;">
                    </p-dropdown>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="generalterminalname" class="font-medium">Terminal Name for General Payments</label>
                    <br>
                    <p-dropdown
                      id="generalterminalname"
                      name="generalterminalname"
                      [options]="StripeTerminals"
                      [ngModel]="selectedGeneralTerminal"
                      (onChange)="onGeneralTerminalChange($event)"
                      (onClear)="selectedGeneralTerminal = null; GeneralTerminalName = ''"
                      optionLabel="label"
                      placeholder="Choose Terminal"
                      [showClear]="true"
                      style="max-width:400px; display:block;">
                    </p-dropdown>
                  </div>

                  <div style="clear:both;width:100%;">&nbsp;</div>

              </p-accordionTab>
                <p-accordionTab>

                  <p-header style="width:100%">
                    <div style="width:100%">
                        <span class="pi pi-image" style="margin-right: 10px;"></span>
                          Visual Settings
                    </div>
                  </p-header>


                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Home Page (Requires you to logout and back in again to show change.)</label><br>
                    <p-dropdown [options]="HomePageList" [style]="{'width': '300px'}" placeholder="Select a Home Page" [showClear]="true" [(ngModel)]="ChosenHomePage" optionLabel="name"></p-dropdown>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Public Booking Wizard Style</label><br>
                    <p-dropdown [options]="PBWStyleStateOptions" [(ngModel)]="vsPBWStyle" [style]="{'width': '300px'}" optionLabel="label" optionValue="value"></p-dropdown>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="ShowGoogleReview" class="font-medium">Show Google Review on Public Booking Wizard</label>
                    <p-selectButton [(ngModel)]="ShowGoogleReview" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions"></p-selectButton>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="GoogleReviewId" class="font-medium">Google Review ID</label><br>
                    <input id="GoogleReviewId" pInputText type="text" [(ngModel)]="GoogleReviewId" style="max-width:300px;">
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="PublicBookingWizardNotesText" class="font-medium">Public Booking Wizard Notes Text</label><br>
                    <input id="PublicBookingWizardNotesText" pInputText type="text" [(ngModel)]="PublicBookingWizardNotesText"
                      placeholder="Is there anything else we should know about your booking?" style="width:100%;max-width:600px;">
                    <small class="block mt-1" style="color:#6c757d;">Leave this empty to use the wording shown above.</small>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="ShowSummaryAtBottomOnDesktop" class="font-medium">Show Summary at the Bottom on Desktop</label>
                    <p-selectButton [(ngModel)]="ShowSummaryAtBottomOnDesktop" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions"></p-selectButton>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="ShowAtAGlanceFigures" class="font-medium">Show Day Summary Figures on At a Glance</label>
                    <p-selectButton [(ngModel)]="ShowAtAGlanceFigures" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions"></p-selectButton>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="ShowNewBookingsOnAtAGlance" class="font-medium">Show New Bookings on At a Glance</label>
                    <p-selectButton [(ngModel)]="ShowNewBookingsOnAtAGlance" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions"></p-selectButton>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="SummaryItinerary" class="font-medium">Show Itinerary on Summary (Public)</label>
                    <p-selectButton [(ngModel)]="SummaryItinerary" [style]="{'width': '150px'}" [options]="intinerarySummaryStateOptions"></p-selectButton>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="SummaryItineraryVenue" class="font-medium">Show Itinerary on Summary (Venue)</label>
                    <p-selectButton [(ngModel)]="SummaryItineraryVenue" [style]="{'width': '150px'}" [options]="intinerarySummaryStateOptions"></p-selectButton>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Public Image</label>
                    <div style="margin-bottom:10px;">
                      <p-selectButton [options]="vsImageModeOptions" [(ngModel)]="vsImageMode" optionLabel="label" optionValue="value" [style]="{'width':'315px'}"></p-selectButton>
                    </div>

                    <ng-container *ngIf="vsImageMode === 'url'">
                      <input id="publicImageURL" pInputText type="text" [(ngModel)]="vsImageURL" style="width:100%;" />
                    </ng-container>

                    <ng-container *ngIf="vsImageMode === 'upload'">
                      <div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;">
                        <p-fileUpload mode="basic" [auto]="true" name="image"
                          url="{{HTMLbmxurl}}/imageupload/{{VenueID}}/{{vsImageGuid}}"
                          accept="image/*" maxFileSize="100000"
                          (onUpload)="uploadedVsImage($event)"
                          chooseLabel="Upload Image">
                        </p-fileUpload>
                        <button *ngIf="vsImageURL" pButton pRipple type="button"
                          style="height:50px;"
                          class="p-button-sm p-element p-button-danger w-auto"
                          (click)="removeVsImage()">
                          <span style="margin-right:8px;" class="pi pi-times"></span>
                          Remove Image
                        </button>
                      </div>
                    </ng-container>

                    <div *ngIf="vsImageURL" style="margin-top:10px;">
                      <img [src]="vsImageURL" style="max-width:400px;max-height:210px;border-radius:4px;" />
                    </div>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">URL to navigate to when clicking on Logo</label>
                    <input id="imageReturnURL" pInputText type="text" [(ngModel)]="vsImageReturnURL" (blur)="ensureHttpPrefix('vsImageReturnURL')" [ngStyle]="{'border-color': (!imageReturnURLValid || !imageReturnURLFormatValid) ? '#FF0000':''}"/>
                  </div>
                  <div *ngIf="!imageReturnURLValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Return URL.</div>
                  <div *ngIf="imageReturnURLValid && !imageReturnURLFormatValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Please enter a valid URL starting with http:// or https://</div>

                  <!-- <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Public Image width (in pixels)</label>
                    <p-inputNumber id="defInterval" [style]="{'width': '300px'}" [(ngModel)]="imageWidth" [showButtons]="true" max="500" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>
                  </div> -->

                  <div style="margin-bottom:20px;">
                    We recommned using an image with a height of 115 pixels for optimal display on the booking wizard, but you can use larger images if you wish. The image width will be scaled down to fit within the booking wizard. (Using this height ensures that the customer can see at least the top three times on the date/time selection on the most popular mobile screen size.)
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Public Image height (in pixels)</label>
                    <p-inputNumber id="defInterval" [style]="{'width': '300px'}" [(ngModel)]="imageHeight" [showButtons]="true" max="500" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Default Background Colour</label><br>
                    <p-colorPicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="defaultBackgroundColour" (onChange)="onBackgroundColourChange()"></p-colorPicker>
                    <input style="width:200px;" [(ngModel)]="defaultBackgroundColour" id="hexcolour" type="text" pInputText (change)="onBackgroundColourChange()">
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Default Button Colour</label><br>
                    <p-colorPicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="defaultColour" (onChange)="onButtonColourChange()"></p-colorPicker>
                    <input style="width:200px;" [(ngModel)]="defaultColour" id="hexcolour" type="text" pInputText (change)="onButtonColourChange()">
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Default Text Colour</label><br>
                    <small class="p-text-secondary" style="display:block; margin-bottom:8px;">Automatically set to black or white based on the background colour for best contrast. You can override this manually.</small>
                    <p-colorPicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="defaultTextColour"></p-colorPicker>
                    <input style="width:200px;" [(ngModel)]="defaultTextColour" id="hexcolour" type="text" pInputText>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Default Button Text Colour</label><br>
                    <small class="p-text-secondary" style="display:block; margin-bottom:8px;">Automatically set to black or white based on the button colour for best contrast. You can override this manually.</small>
                    <p-colorPicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="defaultButtonTextColour"></p-colorPicker>
                    <input style="width:200px;" [(ngModel)]="defaultButtonTextColour" id="hexcolour" type="text" pInputText>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Default Summary Background Colour</label><br>
                    <p-colorPicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="defaultSummaryBackgroundColour"></p-colorPicker>
                    <input style="width:200px;" [(ngModel)]="defaultSummaryBackgroundColour" id="hexcolour" type="text" pInputText>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Default Summary Header/Footer Colour</label><br>
                    <p-colorPicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="defaultSummaryHeaderFooterColour"></p-colorPicker>
                    <input style="width:200px;" [(ngModel)]="defaultSummaryHeaderFooterColour" id="hexcolour" type="text" pInputText>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Default Summary Header/Footer Text Colour</label><br>
                    <p-colorPicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="defaultSummaryHeaderFooterTextColour"></p-colorPicker>
                    <input style="width:200px;" [(ngModel)]="defaultSummaryHeaderFooterTextColour" id="hexcolour" type="text" pInputText>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Default Summary Text Colour</label><br>
                    <p-colorPicker [style]="{'margin-right': '10px'}" [inline]="false" id="colour" [(ngModel)]="defaultSummaryTextColour"></p-colorPicker>
                    <input style="width:200px;" [(ngModel)]="defaultSummaryTextColour" id="hexcolour" type="text" pInputText>
                  </div>


                </p-accordionTab>

                <p-accordionTab>

                  <p-header style="width:100%">
                    <div style="width:100%">
                        <span class="pi pi-money-bill" style="margin-right: 10px;"></span>
                          Payment Settings
                    </div>
                  </p-header>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Payment Sub Account ID</label><br>
                    <input style="width:300px;" [(ngModel)]="RyftSubAccountID" id="hexcolour" type="text" pInputText>
                  </div>
                  
                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Payment Link Template</label><br>
                    <p-dropdown [options]="EmailTemplates" [style]="{'width': '300px', 'float': 'left'}"  placeholder="Select a template" [showClear]="true" [(ngModel)]="selectedPaymentLinkEmailTemplate" optionLabel="name"></p-dropdown>
                  </div>
                  <div style="clear:both;width:100%;height:20px;"></div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Payment Link Expired Template</label><br>
                    <p-dropdown [options]="EmailTemplates" [style]="{'width': '300px', 'float': 'left'}"  placeholder="Select a template" [showClear]="true" [(ngModel)]="selectedCancelledBookingEmailTemplate" optionLabel="name"></p-dropdown>
                  </div>
                  <div style="clear:both;width:100%;height:20px;"></div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Voucher Validity (months)</label><br>
                    <p-dropdown [options]="VoucherValidityOptions" [style]="{'width': '300px', 'float': 'left'}" [(ngModel)]="VoucherValidity" optionLabel="label" optionValue="value"></p-dropdown>
                  </div>

                  <div style="clear:both;width:100%;height:20px;"></div>
                </p-accordionTab>

                <p-accordionTab>

                  <p-header style="width:100%">
                    <div style="width:100%">
                        <span class="pi pi-lock" style="margin-right: 10px;"></span>
                          Beta Settings
                    </div>
                  </p-header>

                  <div class="field mb-4 col-12">
                    <label for="minimalDetails" class="font-medium">Try Beta Tasks. Our task system is in beta mode. You're invited to test it and provide feedback at support&#64;smart-entertainment.co.uk. During the beta phase, this service is free.</label>
                    <p-selectButton [(ngModel)] = "betatask" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions" ></p-selectButton>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="minimalDetails" class="font-medium">Try Beta Memberships. Our membership system is in beta mode. You're invited to test it and provide feedback at support&#64;smart-entertainment.co.uk. During the beta phase, we charge a standard 2% rate on purchases, but there is no processing fee for membership admissions</label>
                    <p-selectButton [(ngModel)] = "betamembership" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions" ></p-selectButton>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="minimalDetails" class="font-medium">Try Beta Emailing. Our messaging system is in beta mode. You're invited to test it and provide feedback at support&#64;smart-entertainment.co.uk. During the beta phase, this service is free.</label>
                    <p-selectButton [(ngModel)] = "betaemailing" [style]="{'width': '150px'}" [options]="minimalDetailsStateOptions" ></p-selectButton>
                  </div>

                  <div style="clear:both;width:100%;height:20px;"></div>
                </p-accordionTab>

                <p-accordionTab>
                  <p-header style="width:100%">
                    <div style="width:100%">
                        <span class="pi pi-file-pdf" style="margin-right: 10px;"></span>
                          Waivers
                    </div>
                  </p-header>

                  <h3>Waiver Sign Up</h3>
                  <div class="field mb-4 col-12">
                    <div style="border: solid #dadee3 1px;border-radius: 7px;padding: 16px; margin-top: 20px;">
                      Waivers allow you to create a waiver/statement of risk document that you can get your customers to sign up to before they arrive.
                      <br><br>
                      There is an additional charge for waivers.
                      <br><br>
                      <div *ngIf="WaiversActive">Waivers are currently switched <b style="color:#EE0000">ON</b>. If you wish to de-activate them then the business owner account will be sent a code. You will not be able to proceed without being able to access that email account.</div>
                      
                      <div *ngIf="!WaiversActive">Waivers are currently switched <b style="color:#EE0000">OFF</b>. If you wish to activate them then the business owner account will be sent a code. You will not be able to proceed without being able to access that email account.</div>
                      <br><br>
                      
                      <button *ngIf="!WaiversActive" pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="activateWaivers();">
                      <span class="pi pi-check" style="margin-right:8px;"></span>  
                      Activate Waivers</button>

                      <button *ngIf="WaiversActive" pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="deactivateWaivers();">
                      <span class="pi pi-times" style="margin-right:8px;"></span>  
                      Deactivate Waivers</button>
                      
                    </div>
                  </div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Minimum Age to Sign Waiver</label><br>
                    <p-dropdown [options]="WaiverAgeList" [style]="{'width': '300px', 'float': 'left'}"  placeholder="Select an Age" [(ngModel)]="MinWaiverAge" optionLabel="name"></p-dropdown>
                  </div>

                  <div style="clear:both;width:100%;">&nbsp;</div>

                  <div class="field mb-4 col-12">
                    <label for="" class="font-medium">Minimum Age to Participate</label><br>
                    <p-dropdown [options]="WaiverAgeList2" [style]="{'width': '300px', 'float': 'left'}"  placeholder="Select an Age" [(ngModel)]="WaiverMinAgeParticipate" optionLabel="name"></p-dropdown>
                  </div>

                  <div style="clear:both;width:100%;">&nbsp;</div>

                </p-accordionTab>

                <p-accordionTab>
                  <p-header style="width:100%">
                    <div style="width:100%">
                        <span class="pi pi-globe" style="margin-right: 10px;"></span>
                          Customer Portal
                    </div>
                  </p-header>

                  <h3>Customer Portal Sign Up</h3>
                  <div class="field mb-4 col-12">
                    <div style="border: solid #dadee3 1px;border-radius: 7px;padding: 16px; margin-top: 20px;">
                      The Customer Portal allows your customers to log in and manage their own bookings online.
                      <br><br>
                      There is an additional charge for the Customer Portal.
                      <br><br>
                      <div *ngIf="CustomerPortalActive">Customer Portal is currently switched <b style="color:#EE0000">ON</b>. If you wish to de-activate it then the business owner account will be sent a code. You will not be able to proceed without being able to access that email account.</div>

                      <div *ngIf="!CustomerPortalActive">Customer Portal is currently switched <b style="color:#EE0000">OFF</b>. If you wish to activate it then the business owner account will be sent a code. You will not be able to proceed without being able to access that email account.</div>
                      <br><br>

                      <!-- <button *ngIf="!CustomerPortalActive" pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="activateCustomerPortal();">
                      <span class="pi pi-check" style="margin-right:8px;"></span>
                      Activate Customer Portal</button>

                      <button *ngIf="CustomerPortalActive" pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="deactivateCustomerPortal();">
                      <span class="pi pi-times" style="margin-right:8px;"></span>
                      Deactivate Customer Portal</button> -->

                    </div>
                  </div>

                  <div class="field mb-4 col-12">
                    <label class="font-medium">Minimum payment amount</label>
                    <p-inputNumber
                      [(ngModel)]="CustomerPortalMinPayment"
                      [min]="1"
                      [showButtons]="true"
                      buttonLayout="horizontal"
                      [prefix]="currencySymbol"
                      [minFractionDigits]="2"
                      [maxFractionDigits]="2"
                      [style]="{'width': '200px'}">
                    </p-inputNumber>
                    <div><small class="text-600">The minimum amount a customer can pay via the portal. If the outstanding balance is less than this amount, the outstanding balance will be used as the minimum instead.</small></div>
                  </div>

                  <div class="field mb-4 col-12">
                    <label class="font-medium">Confirm Number Message</label>
                    <textarea pInputTextarea [(ngModel)]="ConfirmNumberMessage" rows="4" class="w-full"></textarea>
                  </div>

                  <div style="clear:both;width:100%;">&nbsp;</div>

                </p-accordionTab>
              </p-accordion >

              <div class="col-12"> 
                <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateSettingsData();">
                <span class="pi pi-pencil" style="margin-right:8px;"></span>
                Save Changes</button>
                &nbsp;
                <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnHome()">
                <span class="pi pi-times" style="margin-right:8px;"></span>
                Cancel</button>
            </div>
            </p-tabPanel>

            <p-tabPanel header="Social Media" leftIcon="pi pi-share-alt">
              <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
                <span class="pi pi-info-circle" style="margin-right:2px;"></span>
                Configure Open Graph tags to control how your booking page appears when shared on social media.
              </p>

              <div class="surface-card p-4 shadow-2 border-round mb-4">

                <div class="field mb-4 col-12">
                  <label for="ogTitle" class="font-medium">Title</label>
                  <input id="ogTitle" pInputText type="text" [(ngModel)]="ogTitle" [maxlength]="255" style="width:100%;" />
                </div>

                <div class="field mb-4 col-12">
                  <label for="ogDescription" class="font-medium">Description</label>
                  <textarea id="ogDescription" pInputTextarea [(ngModel)]="ogDescription" [maxlength]="500" rows="3" style="width:100%;"></textarea>
                </div>

                <div class="field mb-4 col-12">
                  <label for="ogUrl" class="font-medium">URL</label>
                  <input id="ogUrl" pInputText type="text" [(ngModel)]="ogUrl" [maxlength]="500" style="width:100%;" />
                </div>

                <div class="field mb-4 col-12">
                  <label class="font-medium">Image (The recommended size for FaceBook and X (Formally Twitter) is 1200x630 pixels, if you want to use a different size a ratio of 1.91:1 is recommended)</label>
                  <div style="clear:both;width:100%;margin-bottom:10px;">
                    <p-selectButton [options]="ogImageModeOptions" [(ngModel)]="ogImageMode" optionLabel="label" optionValue="value" [style]="{'width':'315px'}"></p-selectButton>
                  </div>

                  <ng-container *ngIf="ogImageMode === 'url'">
                    <input pInputText type="text" [(ngModel)]="ogImage" [maxlength]="500" placeholder="https://example.com/image.jpg" style="width:100%;" />
                  </ng-container>

                  <ng-container *ngIf="ogImageMode === 'upload'">
                    <div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;">
                      <p-fileUpload mode="basic" [auto]="true" name="image"
                        url="{{HTMLbmxurl}}/imageupload/{{VenueID}}/{{ogImageGuid}}"
                        accept="image/*" maxFileSize="100000"
                        (onUpload)="uploadedOgImage($event)"
                        chooseLabel="Upload Image">
                      </p-fileUpload>
                      <button *ngIf="ogImage" pButton pRipple type="button"
                        style="height:50px;"
                        class="p-button-sm p-element p-button-danger w-auto"
                        (click)="removeOgImage()">
                        <span style="margin-right:8px;" class="pi pi-times"></span>
                        Remove Image
                      </button>
                    </div>
                  </ng-container>

                  <div *ngIf="ogImage" style="margin-top:10px;">
                    <img [src]="ogImage" style="max-width:400px;max-height:210px;border-radius:4px;" />
                  </div>
                </div>

              </div>

              <div class="col-12">
                <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateSettingsData();">
                  <span class="pi pi-pencil" style="margin-right:8px;"></span>
                  Save Changes
                </button>
                &nbsp;
                <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnHome()">
                  <span class="pi pi-times" style="margin-right:8px;"></span>
                  Cancel
                </button>
              </div>
            </p-tabPanel>

        </p-tabView>
        </div>
    </div>
</div>
<style>

:host ::ng-deep .p-chip.custom-chip3 {
    background: #EE0000;
    color: var(--primary-color-text);
    width: 90px;
  }

:host ::ng-deep .p-chip.custom-chip {
  background: var(--primary-color);
  color: var(--primary-color-text);
  width: 90px;
}

.p-chip-text{
  width: 90px;
}
</style>